import React from "react";

import ModalContainer from "../ModalContainer";

import { useDispatch, useSelector } from "react-redux";
import ActiveTableSelector from "../../../pages/OrderDashboard/RightPortion/ActiveTableSelector2";

import {
  changeItemQuantityRedux,
  checkIfQuantityExceeds,
  isThatItemInMyOrder,
  pushItemToActiveOrderRedux,
  removeItemRedux,
} from "../../../redux/reducers/newOrderReducer";

import getOrderNeccesaryData from "../../../helpers/getOrderNeccesaryData";
import moment from "moment";
import { CURRENCY, DATETIMEFORMAT, ITEMSTATUS } from "../../../contants";
import calculateOrderTotals from "../../../helpers/calculateOrderTotals";
import flattentItemsArray from "../../../helpers/flattenItemsArray";
import roundOffTotal from "../../../helpers/roundOffTotal";

const EditOrderModal = ({
  open,
  onClose,
  data: orderData,
  onSubmit,
  mode,
  onPrint,
}) => {
  const isViewMode = mode === "View";
  const ready = getOrderNeccesaryData();

  const [customerName, setCustomerName] = React.useState("");
  const [customerMobile, setCustomerMobile] = React.useState("");

  const isLoading = useSelector((state) => state.util.spinner);
  const [activeOrders, setActiveOrders] = React.useState([]);
  const [editRemarks, setEditRemarks] = React.useState(undefined);

  const handleChangeRemarks = (e) => {
    const {
      target: { value },
    } = e;

    setEditRemarks(value);
  };
  const [activeOldOrders, setActiveOldOrders] = React.useState([]);

  const { allItems } = useSelector((state) => state.order);
  const { enablePrinting, lowerRoundOff, upperRoundOff, standardRoundOff, exclusiveGST } = useSelector((state) => state.util);
  const roundOffType = lowerRoundOff ? "lowerRoundOff" : upperRoundOff ? "upperRoundOff" : "standardRoundOff";

  const activeOrder = activeOrders[0];
  const activeOldOrder = activeOldOrders[0];
  const formatData = (data) => {
    const orderItems = data.orderItems;

    return {
      ...data,
      tablePrice: data?.tablePrice || 0,
      orderItems: orderItems,
      orderType: data.orderType,
      ...(mode === "EditOrder" && { isEdited: true }),
    };
  };

  React.useEffect(() => {
    if (open && activeOrder) {
      setCustomerName(activeOrder.customerName || "");
      setCustomerMobile(activeOrder.customerMobile || "");
    }
  }, [open, activeOrder]);
  
   // Update activeOrders when customer info changes
  const handleCustomerNameChange = (e) => {
    setCustomerName(e.target.value);
    setActiveOrders([
      {
        ...activeOrder,
        customerName: e.target.value,
      },
    ]);
  };

  const handleCustomerMobileChange = (e) => {
    setCustomerMobile(e.target.value);
    setActiveOrders([
      {
        ...activeOrder,
        customerMobile: e.target.value,
      },
    ]);
  };

  const findTableType = (tableNumber) => {
    switch(true){
      case tableNumber?.includes("A") : return "AC";
      case tableNumber?.includes("N") : return "Non AC";
      case tableNumber?.includes("G") : return "Garden";
      case tableNumber?.includes("O") : return "Online";
      case tableNumber?.includes("H") : return "Hut";
      case tableNumber?.includes("R") : return "Room Service";
      case tableNumber?.includes("B") : return "Banquet Hall";
      default : return "default";
    }
  }

  const handleItemQuantity = ({ quantity, itemId, index, item }) => {
    // dispatch(changeItemQuantity(parseInt(quantity), itemindex));
    setActiveOrders([
      ...changeItemQuantityRedux({
        activeOrders,
        refId: activeOrder.refId,
        quantity: quantity,
        itemId: item.id,
        index
      }),
    ]);
  };
  const deleteItem = (item, kotNumber, index) => {
    // dispatch(removeItem(index));
    if (activeOrder.orderItems.length < 2) {
      alert("Can not remove only item from the order");
    } else {
      setActiveOrders([
        ...removeItemRedux({
          activeOrders,
          refId: activeOrder.refId,

          itemId: item.itemId || item.id || item._id,
          index,
        }),
      ]);
    }
  };

  const handleSearchAndAddItem = (selected) => {
    if (selected.length > 0) {
      const item = selected[0];
      const isVariant = item?.isVariant ? true : false;
      const refId = activeOrder.refId;
      const kotIndex = activeOrder.KOTS.length - 1;

      const itemId = item?.variantId || item?.id || item?.id;

      const currItem = isThatItemInMyOrder(activeOrder, itemId, kotIndex);
      if (currItem) {
        if (checkIfQuantityExceeds(currItem, currItem.quantity + 1)) {
          return null;
        }
        setActiveOrders([
          ...changeItemQuantityRedux({
            activeOrders,
            refId: refId,
            quantity: parseInt(currItem.quantity),
            itemId,
            index: kotIndex,
          }),
        ]);
      } else {
        if (checkIfQuantityExceeds(item, 1)) {
          return null;
        }

        const netItem = {
          ...item,
          itemId: item?.variantId || item?._id || item?.id,
          isVariant: isVariant,
          quantity: 1,

          itemTotal: 1 * item.itemPrice,
          itemStatus: ITEMSTATUS[0].key,
          itemStatusId: ITEMSTATUS[0].value,
          kotQuantity: 0,
          kotTotal: 0,
        };

        setActiveOrders([
          ...pushItemToActiveOrderRedux({
            activeOrders,
            refId: activeOrder.refId,
            item: netItem,
          }),
        ]);
      }
    }
  };

  React.useEffect(() => {
    if (open) {
      const myData = formatData(orderData);

      setActiveOrders([myData]);
      if (myData?.oldOrder) {
        const emyData = formatData(orderData.oldOrder);

        setActiveOldOrders([emyData]);
      }
    }
  }, [open]);

  const getData = (orderData) => {
    let mydata = orderData || activeOrder;
    let tableType = findTableType(mydata.tableNumber);
    return mydata
      ? calculateOrderTotals(
          mydata,
          mydata?.cgst,
          mydata?.sgst,
          mydata?.otherCharges,
          mydata?.discount,
          tableType,
          exclusiveGST,
        )
      : {};
  };

  const bottomTableData = (varData) => [
    [
      {
        value: "Order Date : ",
      },
      {
        value: moment(varData.updatedAt).format(DATETIMEFORMAT),
      },
      {
        value: "Sub Total : ",
      },
      {
        value: getData(varData).itemsTotal,
        isCurrency: true,
      },
    ],
    [
      {
        value: "User : ",
      },
      {
        value: varData?.orderBy,
      },
      {
        value: "GST : ",
      },
      {
        renderTd: (row) => (
          <td>
            {CURRENCY}
            {(getData(varData).sgstCharges + getData(varData).cgstCharges).toFixed(2)}
          </td>
        ),
        isCurrency: true,
      },
    ],
    [
      {
        value: "Payment : ",
      },
      {
        value: varData?.paymentType,
      },
      {
        value: "Charges : ",
      },
      {
        value: getData(varData)?.otherCharges,
        isCurrency: true,
      },
    ],
    [
      {
        value: "Customer Name : ",
      },
      {
        value: varData?.customerName,
      },
      {
        value: "Discount : ",
      },
      {
        value: varData?.discount,
        isCurrency: true,
      },
    ],
    [
      {
        value: "Mobile Number : ",
      },
      {
        value: varData?.customerMobile,
      },
      {
        value: "Grand Total : ",
        renderTd: (row) => (
          <td>
            <strong>Grand Total : </strong>
          </td>
        ),
      },
      {
        renderTd: (row) => (
          <td>
            <strong>
              {CURRENCY}
              {roundOffTotal(getData(varData)?.grandTotal, roundOffType)}
            </strong>
          </td>
        ),

        isCurrency: true,
      },
    ],
  ];

  return (
    <div>
      <ModalContainer
        open={open}
        onClose={() => {
          onClose();
          // setFormErrors();
          // reset();
        }}
        title={`Order : # ${activeOrder?.branchOrderNumber}`}
        // title={`${mode} ${title}`}
        size={activeOldOrder ? "xl" : "md"}
      >
        <div class="row">
          {activeOldOrder && (
            <div className="col-md-6">
              <h5>Old Order </h5>

              <ActiveTableSelector
                tables={activeOldOrders}
                activeOrdersLength={1}
                scrollable
                orderDeletable={false}
                active={activeOldOrder}
                handleItemQuantity={() => {}}
                deleteItem={() => {}}
                handleSearchAndAddItem={() => {}}
                allItems={flattentItemsArray(allItems)}
                disabled={true}
                hideSearch={true}
                makeTableActive={() => {}}
                isEditMode
                tableType={findTableType(activeOrder?.tableNumber)}
              />
              <BottomTable tableData={bottomTableData(activeOldOrder)} />
            </div>
          )}

          {activeOrders.length > 0 && (
            <div className={activeOldOrder ? "col-md-6" : "col-md-12"}>
              {activeOldOrder && <h5>Current Order </h5>}

              <ActiveTableSelector
                tables={activeOrders}
                activeOrdersLength={1}
                scrollable
                orderDeletable={false}
                active={activeOrder}
                handleItemQuantity={handleItemQuantity}
                deleteItem={deleteItem}
                handleSearchAndAddItem={handleSearchAndAddItem}
                allItems={flattentItemsArray(allItems)}
                disabled={
                  activeOldOrder || isViewMode || activeOrder?.editCount >= 1
                }
                hideSearch={isViewMode}
                makeTableActive={() => {}}
                isEditMode
                tableType={findTableType(activeOrder?.tableNumber)}
              />

              <div class="form-group row">
                <div class="col-md-6">
                  <label>Customer Name</label>
                  <input
                    type="text"
                    class="form-control"
                    value={customerName}
                    onChange={handleCustomerNameChange}
                    disabled={isViewMode}
                    placeholder="Enter customer name"
                  />
                </div>
                <div class="col-md-6">
                  <label>Customer Mobile</label>
                  <input
                    type="text"
                    class="form-control"
                    value={customerMobile}
                    onChange={handleCustomerMobileChange}
                    disabled={isViewMode}
                    placeholder="Enter mobile number"
                  />
                </div>
              </div>

              <BottomTable tableData={bottomTableData(activeOrder)} />
            </div>
          )}
        </div>
        <div class="form-group mt-3 mb-3">
          <div class={`form-group col-md-${"12"}`}>
            <label>Remarks</label>
            <textarea
              type="text"
              class="form-control"
              placeholder={" Type Remarks"}
              rows={2}
              readOnly={activeOldOrder}
              value={editRemarks || activeOrder?.editRemarks}
              onChange={handleChangeRemarks}
            />
          </div>
        </div>
        <div class="form-group mb-0 mt-3 d-flex justify-content-center">
          {!isViewMode && activeOrder?.editCount < 1 && (
            <button
              type="submit"
              disabled={isLoading}
              class="btn btn-gradient-primary waves-effect waves-light"
              onClick={() => {
                onSubmit({
                  ...activeOrders[0],
                  editRemarks: editRemarks || activeOrder?.editRemarks,
                  ...getData(),
                });
              }}
            >
              {isLoading && (
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              Submit
            </button>
          )}
          <button
            type="reset"
            class="btn btn-gradient-danger waves-effect ml-3"
            onClick={() => onClose()}
          >
            Close
          </button>
          {enablePrinting && (
            <button
              onClick={() => onPrint(activeOrder)}
              type="button"
              class="btn btn-outline-primary ml-3"
            >
              <i class={`dripicons-print mr-2`}></i>
              Print
            </button>
          )}
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditOrderModal;

const BottomTable = ({ tableData }) => {
  return (
    <div>
      <div class="table-responsive-sm">
        <table class="table table-sm mb-0">
          <tbody>
            {tableData.map((row, rowIndex) => {
              return (
                <tr>
                  {row.map((td) => {
                    if (td.renderTd) {
                      return td.renderTd();
                    }
                    return (
                      <td>
                        {" "}
                        {td.isCurrency ? CURRENCY : ""}
                        {td.value}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const styles = {
  paginated: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "0px 1vw",
    maxWidth: "20vw",
  },
  select: {
    margin: "0px 0.5vw",
  },
  searchGroup: {
    maxWidth: "15vw",
  },
};

